import { instance2, instance3 } from "App/constants"
import { today, isNull } from "App/utils/helpers"
import { requiredMsg } from "App/utils/validation"
import { STATUS_OPEN_DRAFT_TAGIHAN } from "utils/billing"

export const urlGetKelasKunjungan =
  "/registration/kelaskunjungan/listkelaskunjungan_itgh"
export const urlGetJenisLayanan = "/jenis_layanan/listjenis_layanan_itgh"
export const urlGetAsuransi = "/insurance/listinsurance_itgh"
export const urlGetPatientInternal = "/patient/listpatientsfilter_itgh"
export const urlGetPatientExternal = "/patient/listpatientsfilter_external_itgh"

export const urlAddTagihan = "/tagihan/register"
export const urlGetTagihanById = "/tagihan/listTotalByTagihanId"
export const urlGetKunjungan =
  "/registration/registration/listregistration_billing_itgh"

export const urlGetDitanggungByTagihanId = "/ditanggung/list"
export const urlAddDitanggung = "/ditanggung/register"
export const urlUpdateDitanggung = "/ditanggung/update"

export const urlAddKunjungan = "/poolKunjungan/register"
export const urlGetKunjunganByTagihanId = "/poolKunjungan/list"

export const urlTambahPaket = "/tagihan-paket/add"

export const urlGetPenjualanByTagihanId = "/poolKunjungan/listPenjualanById"
export const urlGetBayarByTagihanId = "/bayar/detailsByTagihanId"

export const MSG_ERROR_TAGIHAN_NULL = "Buka transaksi tagihan terlebih dahulu"

export const RESET_STATE_INPUT_TAGIHAN = {
  tagihan_id: "",
  date: today(true),

  rm_id: "",
  rm_name: "",
  rm_umur: "",
  rm_tanggal_lahir: "",
  untuk_pembayaran: "",

  kelas_id: null,
  kelas_name: "Pilih Kelas",

  asuransi_no: "",
  asuransi_id: null,
  asuransi: "Pilih Asuransi",

  jenis_layanan_id: null,
  jenis_layanan_name: "Pilih Jenis Layanan",

  kunjungan_id: "",
  no_sep: "",
  no_npwp: "",
  penanggung: "",

  keterangan: "",
  status: 0,
  jenisrm: 2,

  biaya_administrasi: "",

  tagihan: {
    jumlah: 0,
    potongan: 0,
    tax: 0,
    total_tagihan: 0,
  },

  pembayaran: {
    total_tagihan: 0,
    total_pembayaran: 0,
  },

  ditanggung: {
    ditanggung: 0,
    total_tagihan: 0,
    jumlah_selisih: 0,
  },

  totalPaket: {
    total_tagihan: 0,
    total_paket: 0,
    jumlah_selisih: 0,
  },

  total_saldo: 0,

  status_tagihan: STATUS_OPEN_DRAFT_TAGIHAN,

  is_paket: false,

  is_checkout_bed: false,

  final_tagihan: null,
}

export const STATE_TAMBAH_PAKET = {
  id_tagihan: null,
  id_mh_paket: null,
  id_paket: null,
  harga_awal: 0,
  harga: 0,
  nama_paket: "",
  remark: "",
}

export const sumTotalItem = (rows, keyValue) => {
  let sum = 0
  rows.map((a) => {
    return a[keyValue].map((x) => {
      const total = x.hargaCustom * x.qty
      return (sum += total)
    })
  })
  return sum
}
export const getTotalSaldoByTagihanId = async (id) => {
  try {
    const res = await instance3.get(`/kas/saldo/detailsByTagihanId/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.totalSaldo,
      }
    } else {
      return {
        state: false,
        data: 0,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      data: 0,
      message: error?.response?.data?.message,
    }
  }
}

export const getTagihanById = async (id) => {
  try {
    const api2 = await instance3.get(`${urlGetTagihanById}/${id}`)
    const api = api2.data
    if (api.status === 200) {
      return {
        state: true,
        data: {
          tagihan: {
            jumlah: api.data[0].tagihan.jumlahTotalPenjualan,
            potongan: api.data[0].tagihan.jumlahTotalPotongan,
            tax: api.data[0].tagihan.jumlahTotalTax,
            total_tagihan:
              api.data[0].tagihan.jumlahTotalPenjualanSetelahTaxdanPot,
          },
          pembayaran: {
            total_tagihan: api.data[1].pembayaran.jumlahTotalTagihan,
            total_pembayaran: api.data[1].pembayaran.jumlahTotalBayarJual,
          },
          ditanggung: {
            ditanggung: api.data[2].ditanggung.jumlahTotalDitanggung,
            total_tagihan: api.data[2].ditanggung.jumlahTotalTagihan,
            jumlah_selisih: api.data[2].ditanggung.jumlahSelisih,
          },
          totalPaket: {
            total_tagihan: api?.data[4]?.paket?.jumlahTotalTagihan ?? 0,
            total_paket: api?.data[4]?.paket?.jumlahTotalPaket ?? 0,
            jumlah_selisih: api?.data[4]?.paket?.jumlahSelisih ?? 0,
          },
        },
      }
    } else {
      return {
        state: false,
        message: api.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getPrintTagihanById = async (id) => {
  try {
    const api2 = await instance3.get(`/tagihan/printByTagihanId/${id}`)
    const api = api2.data
    if (api.status === 200) {
      return {
        state: true,
        data: api.data,
      }
    } else {
      return {
        state: false,
        message: api.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getExportTagihanById = async (id, scaleValue = undefined) => {
  try {
    const api2 = await instance3.get(`/tagihan/exportPdfByTagihanId/${id}`, {
      responseType: "blob",
      params: {
        scale: scaleValue,
      },
    })
    return {
      state: true,
      data: api2.data,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getExportTagihanByIdV2 = async (id, scaleValue = undefined) => {
  try {
    const api2 = await instance3.get(
      `/tagihan/export-rincian-tagihan-dengan-diskon/${id}`,
      {
        responseType: "blob",
        params: {
          scale: scaleValue,
        },
      },
    )
    return {
      state: true,
      data: api2.data,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getStatusFinalJasmed = async (id) => {
  try {
    const api2 = await instance3.get(`/tagihan/get-final-tagihan`, {
      params: {
        id_tagihan: id,
      },
    })
    return {
      state: true,
      data: api2.data,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getDitanggungByTagihanId = async (id) => {
  try {
    const res = await instance3.get(`${urlGetDitanggungByTagihanId}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getKunjunganByTagihanId = async (id) => {
  try {
    const res = await instance3.get(`${urlGetKunjunganByTagihanId}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getPenjualanByTagihanId = async (id) => {
  try {
    const res = await instance3.get(`${urlGetPenjualanByTagihanId}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getBayarByTagihanId = async (id) => {
  try {
    const res = await instance3.get(`${urlGetBayarByTagihanId}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getExternalByTagihanId = async (id) => {
  try {
    const res = await instance3.get(`/poolExternal/list/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const validationInputTagihan = (formData) => {
  const errors = {}

  if (isNull(formData.jenis_layanan_id)) {
    errors["jenis_layanan_id"] = requiredMsg("Jenis Layanan")
  }

  if (isNull(formData.kelas_id)) {
    errors["kelas_id"] = requiredMsg("Kelas")
  }

  if (
    isNull(formData.tagihan_id) &&
    formData.asuransi.toLowerCase().includes("bpjs")
  ) {
    if (isNull(formData.asuransi_no)) {
      errors["asuransi_no"] = requiredMsg("Nomor Asuransi")
    }

    if (isNull(formData.no_sep)) {
      errors["no_sep"] = requiredMsg("Nomor SEP")
    }
  }

  return errors
}

export const getListPaket = async (id) => {
  try {
    const api = await instance3.get("/tagihan-paket/list-tagihan-paket", {
      params: {
        id_tagihan: id,
      },
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
      }
    } else {
      return {
        state: false,
        data: [],
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteListPaket = async (id) => {
  try {
    const api = await instance3.post("/tagihan-paket/delete", {
      id_tagihan_paket: id,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const checkoutBedTagihan = async (id) => {
  try {
    const api = await instance2.post("/bed/cron_bed_penjualan", {
      id_kunjungan: id,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getExportTagihanBillingObatKronis = async ({
  id_tagihan,
  id_kunjungan,
}) => {
  try {
    const api2 = await instance3.get(
      `/tagihan/export-rincian-tagihan-obat-kronis`,
      {
        params: {
          id_tagihan,
          id_kunjungan,
        },
        responseType: "blob",
      },
    )
    return {
      state: true,
      data: api2.data,
    }
  } catch (error) {
    let message = "Terjadi kesalahan pada server"
    // Jika responsenya blob, ubah ke teks agar bisa dibaca
    if (error?.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text() // ubah blob ke string
        const json = JSON.parse(text) // coba parse ke JSON
        message = json?.message || message
      } catch (parseError) {
        // jika parsing gagal, fallback ke default
        message = "Gagal membaca pesan error dari server"
      }
    } else {
      // kalau bukan blob, ambil langsung
      message = error?.response?.data?.message || error?.message
    }

    return {
      state: false,
      message,
    }
  }
}
